import { Form } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import EditorCk from './Editor';

export default function FormItem({
    label,
    name,
    initialValue,
    editor = {
        title: false,
        description: false,
        hideToolbar: false,
    },
    rules = [],
    isListField = false,
}) {
    return (
        <Form.Item
            label={label}
            name={name}
            initialValue={initialValue}
            rules={rules}
            isListField={isListField}
        >
            <EditorCk
                title={editor.title}
                description={editor.description}
                hideToolbar={editor.hideToolbar}
            />
        </Form.Item>
    );
}

FormItem.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    initialValue: PropTypes.any,
    editor: PropTypes.shape({
        title: PropTypes.bool,
        description: PropTypes.bool,
        hideToolbar: PropTypes.bool,
    }),
    rules: PropTypes.array,
    isListField: PropTypes.bool,
};
